module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-forgot-password"
  }, [_c('app-navigation', {
    attrs: {
      "currentSpace": _vm.$t('web.reset_password.nav_space')
    }
  }), _vm._v(" "), _c('main', {
    staticClass: "o-forgot-password__main"
  }, [_c('section', {
    staticClass: "c-card js-reset-validation-shake"
  }, [_c('form', [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.reset_password.card_header')))])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body"
  }, [(_vm.error_message) ? _c('div', {
    staticClass: "c-form-validation t-alert-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.error_message) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.is_password_expired && !_vm.error_message) ? _c('div', {
    staticClass: "c-form-validation t-alert-info"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.reset_password.expired_password')) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "o-fieldset"
  }, [_c('label', {
    staticClass: "u-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.reset_password.new_password_label')))]), _vm._v(" "), _c('ul', {
    staticClass: "u-tiny-list"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('web.reset_password.new_password_minimum_12_characters')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('web.reset_password.new_password_minimum_1_number')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('web.reset_password.new_password_minimum_1_symbol')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('web.reset_password.new_password_minimum_1_uppercase')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.password),
      expression: "request.password"
    }],
    attrs: {
      "id": "password",
      "type": "password",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.request.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.password) ? _c('div', {
    staticClass: "c-validation t-alert-danger",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.errors.password[0]) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('fieldset', {
    staticClass: "o-fieldset"
  }, [_c('label', {
    staticClass: "u-label",
    attrs: {
      "for": "password_confirmation"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.reset_password.confirm_new_password_label')) + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.password_confirmation),
      expression: "request.password_confirmation"
    }],
    attrs: {
      "id": "password_confirmation",
      "type": "password",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.request.password_confirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "password_confirmation", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.password_confirmation) ? _c('div', {
    staticClass: "c-validation t-alert-danger",
    attrs: {
      "for": "password_confirmation"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.errors.password_confirmation[0]) + "\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__footer"
  }, [(!_vm.is_password_expired) ? _c('router-link', {
    staticClass: "c-card__footer__text-link u-tiny-note u-float-left t-link",
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.reset_password.login_link')) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "c-button u-float-right t-button-primary",
    on: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.is_password_expired ? _vm.$t('web.settings.save_button') : _vm.$t('web.reset_password.save_and_login')) + "\n          ")])], 1)])])]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03276eca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ResetPassword.vue
// module id = 507
// module chunks = 1